import React, {Component} from "react";
import "./zocial.css";
import "./Login.css";
import "./Navigation.css";
import "./styles.css";
import "../../Common/Common.css";
import {RESOURCE_BASE_URL, BASE_URL} from "../../../configuration";
import axios from 'axios';
import App from "../../../App";

class OAuth2Handler extends Component {

    constructor(props) {
        super(props);

        this.redirectToHome = this.redirectToHome.bind(this);
        this.redirectToHome();
    }

    componentDidMount() {
        this.redirectToHome();
    }


    redirectToHome = () => {
        const {match: {params}} = this.props;
        let tokenString = params.oauthToken;

        if (tokenString) {
            let newTokenString = "Bearer " + tokenString;
            let axiosConfig = {
                headers: {
                    'Authorization': newTokenString.toString()
                }
            };
            console.log("Google Oauth Handle token ====>", newTokenString);
            axios.get(RESOURCE_BASE_URL + 'api/user-new', axiosConfig)
                .then((res) => {
                    let userRole = res.data.payload.userRoles;
                    localStorage.setItem("userRole", userRole);
                }).catch((err) => {
                console.log("Get user Id error", err);
            })

            localStorage.setItem("logStatus", "logged");
            localStorage.setItem("tokenString", newTokenString);
            window.location.href = BASE_URL;
        }

    }

    render() {
        return (
            <div></div>
        )
    }

}

export default OAuth2Handler;



// WEBPACK FOOTER //
// ./src/components/Site/Login/OAuth2Handler.js